import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { Menu} from 'antd';
import 
{BellOutlined,
  UserOutlined,
  EditOutlined,
  BookOutlined,
  LogoutOutlined,
  LoginOutlined,
} 
from '@ant-design/icons';
import logo from '../../constants/secresilk-logo.png';

import * as ROUTES from '../../constants/routes';
import { AuthUserContext } from '../Session';
import SignInForm from '../SignIn';
import SignUpForm from '../SignUp';
import PasswordForgetForm from '../PasswordForget';
import { withFirebase } from '../Firebase';
import {ShelfIcon} from '../Icons';




const SubMenu = Menu.SubMenu;
// const SigninMenu = SignInForm(Menu.Item);
const modalList = ['signin', 'signup', 'pwforget'];

// Place react component in menubar; vanilla html would result in many console errors
const LogoImage = () => <img style={{ height: "50px", paddingLeft: 12 }} src={logo} alt="Logo" />;






class NavigationBase extends Component {

  constructor(props) {
    super(props);

    this.state = {
      current: 'login',
      // signinSpin: false,
      // signinVisible: (this.props.location && this.props.location.state && this.props.location.state.visible) || false,
      signinVisible: false,
      signupVisible: false,
      pwforgetVisible: false,
    }

  }

  handleClick = (e) => {
    // console.log('click ', e);
    this.setState({
      current: e.key,
    });
  }



  showModal = (key) => {
    const obj = Object.assign(...modalList.map(i => ({ [`${i}Visible`]: i === key })));
    this.setState(obj);
  }



  cancelModal = (key) => {
    const stateName = `${key}Visible`;

    this.setState({
      [stateName]: false,
    });

  }




  render() {

    const { signinVisible, signupVisible, pwforgetVisible } = this.state;



    return (
      <React.Fragment>
        <SignUpForm visible={signupVisible} handleCancel={() => this.cancelModal("signup")} />
        <SignInForm visible={signinVisible} handleCancel={() => this.cancelModal("signin")} handleSignup={() => this.showModal("signup")} handlePwforget={() => this.showModal("pwforget")} />
        <PasswordForgetForm visible={pwforgetVisible} handleCancel={() => this.cancelModal("pwforget")} />
        <div style={{ maxWidth: 600, margin: "auto", marginTop: 20 }} >
        <AuthUserContext.Consumer>


          {authUser =>
            authUser ?
              <Menu
                onClick={this.handleClick}
                selectedKeys={[this.state.current]}
                mode="horizontal"
              >
                <LogoImage />
                <SubMenu title={<span className="submenu-title-wrapper"><BookOutlined />Notes</span>}>
                  <Menu.Item key="notebooks">
                    <Link to={ROUTES.NOTEBOOKS}><ShelfIcon style={{ fontSize: '16px', position: "relative", top: 1 }}/>Notebooks</Link>
                  </Menu.Item>
                  <Menu.Item key="note">
                    <Link to={ROUTES.EDIT}><EditOutlined />Note</Link>
                  </Menu.Item>
                </SubMenu>
                <SubMenu title={<span className="submenu-title-wrapper"><UserOutlined />My Account</span>}>
                  <Menu.Item key="logout" onClick={this.props.firebase.doSignOut}>
                  <LogoutOutlined />Log Out
                </Menu.Item>
                </SubMenu>
                <Menu.Item key="notifications">
                <BellOutlined />
              </Menu.Item>

              </Menu>

              :

              <Menu
                onClick={this.handleClick}
                selectedKeys={[this.state.current]}
                mode="horizontal"
              >
                <LogoImage />
                <Menu.Item key="login" onClick={() => this.showModal("signin")}>
                  <LoginOutlined />Log in
              </Menu.Item>
              </Menu>
          }

        </AuthUserContext.Consumer>
        </div>
      </React.Fragment>
    );

  }

}


const Navigation = compose(
  withRouter,
  withFirebase,
)(NavigationBase);

export default Navigation;